<template>
  <main class="tokyo">
    <Menu />
    <hero />
    <sponsors />
    <agenda />
    <speakers />
    <presenters />
    <partners />
  </main>
</template>

<style lang="scss" scoped>
  @import '@/styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import Menu from '@/components/tokyo/menu.vue';
import hero from '@/components/tokyo/hero.vue';
import agenda from '@/components/tokyo/agenda.vue';
import sponsors from '@/components/tokyo/sponsors.vue';
import speakers from '@/components/tokyo/speakers.vue';
import presenters from '@/components/tokyo/presenters.vue';
import partners from '@/components/tokyo/partners.vue';

export default {
  name: 'Home',
  components: {
    Menu,
    hero,
    agenda,
    sponsors,
    presenters,
    speakers,
    partners
  },
};
</script>

<style lang="scss" scoped>
  .tokyo {
    &#single-schedule {
      padding: 30px 0;
    }
  }
</style>